/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCallExecution200Response
 */
export interface CreateCallExecution200Response {
    /**
     * 
     */
    data?: { [key: string]: any | null; };
}

/**
 * Check if a given object implements the CreateCallExecution200Response interface.
 */
export function instanceOfCreateCallExecution200Response(value: object): value is CreateCallExecution200Response {
    return true;
}

export function CreateCallExecution200ResponseFromJSON(json: any): CreateCallExecution200Response {
    return CreateCallExecution200ResponseFromJSONTyped(json, false);
}

export function CreateCallExecution200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallExecution200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function CreateCallExecution200ResponseToJSON(json: any): CreateCallExecution200Response {
    return CreateCallExecution200ResponseToJSONTyped(json, false);
}

export function CreateCallExecution200ResponseToJSONTyped(value?: CreateCallExecution200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

